import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ftb-sequence-list',
  templateUrl: './sequence-list.component.html',
  styleUrls: ['./sequence-list.component.scss']
})
export class SequenceListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
